
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class RaccomandazioniDialog extends Serenity.EntityDialog<RaccomandazioniRow, any> {
        protected getFormKey() { return RaccomandazioniForm.formKey; }
        protected getIdProperty() { return RaccomandazioniRow.idProperty; }
        protected getLocalTextPrefix() { return RaccomandazioniRow.localTextPrefix; }
        protected getNameProperty() { return RaccomandazioniRow.nameProperty; }
        protected getService() { return RaccomandazioniService.baseUrl; }
        protected getDeletePermission() { return RaccomandazioniRow.deletePermission; }
        protected getInsertPermission() { return RaccomandazioniRow.insertPermission; }
        protected getUpdatePermission() { return RaccomandazioniRow.updatePermission; }

        protected form = new RaccomandazioniForm(this.idPrefix);

    }
}